// extracted by mini-css-extract-plugin
export var root = "Headline-root-uzZry";
export var rootDescription = "Headline-root_description-T4ChT";
export var rootHeading = "Headline-root_heading-1xOOJ";
export var rootImage = "Headline-root_image-SqLnv";
export var rootPicture = "Headline-root_picture-gsh7c";
export var rootRow = "Headline-root_row-Np82V";